import React from 'react';
import { Box, BoxProps, SxProps } from '@mui/material';
import { CSSProperties } from '@mui/styles';
import { Loader } from '@x5-react-uikit/core';
import { tableStyles } from './styles';

interface Props extends BoxProps {
  children?: React.ReactNode;
  colSpan?: number;
  isEmpty?: boolean;
  isLoading?: boolean;
  sx?: SxProps;
  tableLayout?: 'auto' | 'fixed' | 'inherit' | 'initial' | 'revert' | 'unset';
}

const Table: React.FC<Props> = ({
  children,
  colSpan = 100,
  isEmpty,
  isLoading,
  sx,
  tableLayout = 'auto',
  ...rest
}: Props) => {
  const sxStyles = [
    tableStyles.root,
    !isEmpty && { tableLayout },
    sx as CSSProperties,
  ];

  return (
    <Box component="table" mb="44px" sx={sxStyles} {...rest}>
      {isEmpty ? (
        <>
          {children}
          <tbody>
            <tr>
              <td colSpan={colSpan} align="center">
                {isLoading ? <Loader /> : 'Нет данных для отображения'}
              </td>
            </tr>
          </tbody>
        </>
      ) : (
        children
      )}
    </Box>
  );
};

export default Table;
